import type { ReactNode } from 'react';

import { RefusedRedirect } from '@/auth/PageGate';

import { type TenantCapabilities, useTenantCapabilities } from './feature';

/**
 * Route gate from the identity service's capabilities of the ACTIVE role
 * (GET admin/tenant/capabilities, admin-levels-2026-10-15.md section 7):
 * the page mounts, and fires its requests, only when `capability` is true
 * (a list: any of them); otherwise /nopermission (the role's home on its first landing,
 * auth/PageGate.tsx `RefusedRedirect`). While the answer is loading it shows `fallback`.
 * An identity service that does not answer (older, not set up, offline)
 * offers nothing.
 */
export function CapabilityGate({
  capability,
  children,
  fallback = null,
}: {
  capability: keyof TenantCapabilities | (keyof TenantCapabilities)[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const caps = useTenantCapabilities();
  if (caps === null) return <>{fallback}</>;
  const allowed = (Array.isArray(capability) ? capability : [capability]).some((c) => caps[c]);
  return allowed ? <>{children}</> : <RefusedRedirect />;
}
